module.exports = __webpack_public_path__ + "img/5.42b7fc52.png";